<template>
  <div class="page-payment">
    <Overlay
      width="x-small"
      autoHeight
      :link="closeLink">

      <SubscriptionInfo
        :site="site"
        :companyId="companyId"
        :siteId="siteId"/>
    </Overlay>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import page from '@/mixins/page'
import {readCompanySiteData} from '@/lib/sites'

import SubscriptionInfo from '@/components/SubscriptionInfo'
import Overlay from '@/components/Overlay'

export default {
  name: 'plan',

  mixins: [page],

  data() {
    return {
      title: 'Plan Info',
      site: {}
    }
  },

  props: {
    siteId: String,
    companyId: String
  },

  components: {
    SubscriptionInfo,
    Overlay
  },

  computed: {
    ...mapState(['currentUser']),

    closeLink() {
      if (this.$route.name === 'site-select-plan') {
        return {name: 'site'}
      } else {
        return {name: 'plans'}
      }
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId)
        .then(({data}) => {
          this.site = data
        })
        .catch(() => {

        })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    '$route'() {
      this.getData()
    }
  }
}
</script>
